import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'
import { useRoomStore } from '@/stores/room'

/**
 * returns whether the corresponding button should be visible and enabled
 * - button `visible` if one of the `capabilities` is enabled and the FF is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useSelfLayoutButtonState = () => {
  const isAudioOnly = useRoomStore(state => state.isAudioOnly)

  const selfPositionCapability = useCapabilitiesStore(
    state => state.selfPositionCapability,
  )
  const selfSetLayoutCapability = useCapabilitiesStore(
    state => state.selfSetLayoutCapability,
  )
  const isFeatureDisabled = useFeaturesStore(
    state => state.disabled.ROOM_LAYOUT === FEATURES.ROOM_LAYOUT,
  )

  // button visible if one of the capabilities is enabled and FF is enabled
  const isRoomLayoutButtonVisible =
    !isAudioOnly &&
    !isFeatureDisabled &&
    (selfPositionCapability || selfSetLayoutCapability)

  const canSetPosition = selfPositionCapability
  const canSetLayout = selfSetLayoutCapability

  return {
    canSetLayout,
    canSetPosition,
    isRoomLayoutButtonVisible,
  }
}
